import { useMutation, useQueryClient } from "@tanstack/react-query";
import { syncProviders, syncBasketballProviders } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "@/tanstackQuery/queries/leaguesNew";
import { CategoriesStatsQueryKeys } from "@/tanstackQuery/queries/categoriesStats";

const invalidateLeagueData = (
  queryClient: ReturnType<typeof useQueryClient>
) => {
  queryClient.invalidateQueries({
    queryKey: [LeaguesNewQueryKeys.LeaguesNew],
  });
  queryClient.invalidateQueries({
    queryKey: [LeaguesNewQueryKeys.LeagueMappings],
  });
  queryClient.invalidateQueries({
    queryKey: [CategoriesStatsQueryKeys.CategoriesStats],
  });
};

export const useSyncProviders = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => syncProviders(),
    onSuccess: () => invalidateLeagueData(queryClient),
  });
};

export const useSyncBasketballProviders = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => syncBasketballProviders(),
    onSuccess: () => invalidateLeagueData(queryClient),
  });
};
